import React from "react";
import { useLocation } from "react-router-dom";

const TopOffers = () => {
  const location = useLocation();

  const offers = Array.isArray(location.state?.offers)
    ? location.state.offers
    : [];

  return (
    <div className="min-h-screen bg-[#F8F9FB] px-5 py-8">
      <div className="mx-auto max-w-[1200px]">
        {/* Heading */}
        <h1 className="mb-6 text-2xl font-bold text-[#222]">Top Offers</h1>

        {offers.length === 0 ? (
          <div className="rounded-xl bg-white p-8 text-center text-gray-500">
            No offers available right now.
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {offers.map((item, index) => (
              <div
                key={`${item?.item_id}-${item?.restaurantUserId}-${index}`}
                className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm"
              >
                {/* Image */}
                <div className="h-[200px] w-full bg-gray-100">
                  {item?.photo || item?.item_image || item?.itemImage ? (
                    <img
                      src={item?.photo || item?.item_image || item?.itemImage}
                      alt={item?.item_name || "Food item"}
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <div className="flex h-full items-center justify-center text-sm text-gray-400">
                      No Image
                    </div>
                  )}
                </div>

                <div className="p-4">
                  {/* Restaurant */}
                  <p className="mb-1 text-xs font-medium text-gray-500">
                    {item?.restaurantName || "Restaurant"}
                  </p>

                  {/* Item Name */}
                  <h2 className="text-lg font-semibold text-[#222]">
                    {item?.item_name || "Menu Item"}
                  </h2>

                  {/* Category */}
                  {item?.categoryName && (
                    <p className="mt-1 text-xs text-gray-400">
                      {item.categoryName}
                    </p>
                  )}

                  {/* Price */}
                  <div className="mt-3 flex items-center gap-2">
                    <span className="text-sm text-gray-400 line-through">
                      ₹{item?.price}
                    </span>

                    <span className="text-lg font-bold text-[#11182A]">
                      ₹{item?.discountPrice}
                    </span>

                    {/* Discount */}
                    {item?.discount && (
                      <span className="rounded-md bg-green-100 px-2 py-1 text-xs font-semibold text-green-600">
                        {item.discount}% OFF
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TopOffers;
